export default __webpack_public_path__ + "static/media/uae.acec25af.svg";